import baseURL from '../modules/api/url'
import { strings } from '../context/LanguageContext/strings'
import { ManageImports } from '../constants/ManageImports'

export const ManageInventoryImports = {
    getInventoryImportsFilters: () => [
        {
            type: 'list',
            key: 'store_id',
            display_name: strings.SECTION_MANAGE_STORES_IMPORTS_TABLE_STORE_ID,
            display_value: [],
            post_value: [],
            defaultDisplayValue: [],
            defaultPostValue: [],
        },
        {
            type: 'list',
            key: 'product_id',
            display_name: strings.SECTION_MANAGE_PRODUCTS_IMPORTS_TABLE_PRODUCT_ID,
            display_value: [],
            post_value: [],
            defaultDisplayValue: [],
            defaultPostValue: [],
        },
        {
            type: 'list',
            key: 'status',
            display_name: strings.STATUS,
            display_value: [],
            post_value: [],
            displayPillUtil: list => {
                const statuses = ManageImports.getStatuses()
                return list.map(item => statuses.find(s => s.value === item).display)
            },
            defaultDisplayValue: [],
            defaultPostValue: [],
        },
        {
            type: 'list',
            key: 'action',
            display_name: strings.ACTION,
            display_value: [],
            post_value: [],
            displayPillUtil: list => {
                const actions = ManageImports.getActions()
                return list.map(item => actions.find(a => a.value === item).display)
            },
            defaultDisplayValue: [],
            defaultPostValue: [],
        },
    ],
    getInventoryImportsTableHeaders: () => [
        {
            id: 'store_id -> product_id',
            label: strings.SECTION_MANAGE_INVENTORY_IMPORTS_TABLE_INVENTORY_ID,
            width: '20%',
            align: 'center',
        },
        {
            id: 'quantity',
            label: strings.SECTION_MANAGE_INVENTORY_IMPORTS_TABLE_QUANTITY,
            width: '20%',
        },
        {
            id: 'status',
            label: strings.STATUS,
            width: '25%',
        },
        {
            id: 'action',
            label: strings.ACTION,
            width: '20%',
        },
        {
            id: 'created_at',
            label: strings.SECTION_MANAGE_IMPORTS_TABLE_CREATE_AT,
            width: '20%',
        },
    ],
    inventoryImportsUrlPath: `${baseURL.SEVEN_NOW_CORE_API_URL}/inventory/inventory/storeInventoryImport`,
    inventoryImportsSyncUrlPath: `${baseURL.SEVEN_NOW_CORE_API_URL}/inventory/storeInventoryImport/sync`,
}
